import { useAction } from 'next-safe-action/hooks'

import { updateGuestReceiptInformation } from '@/entities/contract'
import { TReceiptInformation } from '@/entities/user'
import { useServerErrorHandler } from '@/shared/config'

type Props = {
  onSuccess?: () => void
}

export const useUpdateGuestReceiptInformation = ({ onSuccess }: Props) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(updateGuestReceiptInformation, {
    onSuccess,
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const updateReceiptInformation = (
    contractId: number,
    receiptInformation: TReceiptInformation,
  ) => {
    if (!contractId) {
      return
    }

    action.execute({
      body: {
        receiptInfo: receiptInformation,
      },
      contractId: Number(contractId),
    })
  }

  return updateReceiptInformation
}
